import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=5c71b74f&scoped=true&"
import script from "./Student.vue?vue&type=script&lang=ts&"
export * from "./Student.vue?vue&type=script&lang=ts&"
import style0 from "./Student.vue?vue&type=style&index=0&id=5c71b74f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c71b74f",
  null
  
)

export default component.exports